
















































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {ExpensePaymentType, PickingListCostType} from "@/enums/type";
import {BillLadingFeeType} from "@/enums/type/billladingfeetype";
import {PickingListCostStore} from "@/modules/pickinglistcost";

@Component({
  name: "PLCostExcel",
})
export default class extends mixins(CommonMixin) {
    @Prop({required: true, type: Number}) readonly id!: number;
    @Prop({type: Boolean, default: false}) readonly isPrint!: boolean;
    ExpensePaymentType = ExpensePaymentType;
    BillLadingFeeType = BillLadingFeeType;
    PickingListCostType = PickingListCostType

    get costBillLadings() {
        return PickingListCostStore.pickingListCostBillLadings;
    }

    get pickingListCost() {
        return PickingListCostStore.data[this.id];
    }

    getMoney(data: any) {
        const fee = this.getProp(data, 'fee');
        return fee !== undefined && fee !== null ? fee : this.getProp(data, 'totalMoney');
    }

}
